import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Modal,
    Paper,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from "@mui/material";
import JSConfetti from "js-confetti";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    useGetQuizQuestionByQuizIdListMutation,
    useGetQuizResponseMutation,
    useGetSspiQuestionListMutation,
    useGetSspiResponseMutation,
} from "../../apiSlice";
import SideBar from "../Dashboard/StudentDashboard/Sidebar/SideBar";
import Breadcrumb from "../StudentBreadcrumb/Breadcrumb";

const AssessmentContent = () => {
    const navigate = useNavigate();

    // const location = useLocation();
    // const {quizId} = location.state || {};

    // console.log(quizId);

    // const [questions, setQuestions] = useState([]);
    const [questions, setQuestions] = useState([]);

    const [open, setOpen] = useState(false);
    const [error, setError] = useState(null);
    const [isError, setIsError] = useState(false);
    const [isLastQuestion, setIsLastQuestion] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [assessmentResponse, setAssessmentResponse] = useState([]);
    const [] = useState({});
    const [loading, setLoading] = useState({
        questions: true,
        submission: false,
    });
    const [timeLeft, setTimeLeft] = useState(600); // 10 minutes
    const [studentQuizQuestionsByIdAPI] =
        useGetQuizQuestionByQuizIdListMutation();

    const [assessmentSubmissionAPI] = useGetSspiResponseMutation();
    const [assessmentQuestionListAPI] = useGetSspiQuestionListMutation();

    const [submitQuiz] = useGetQuizResponseMutation();
    const [jsConfetti, setJsConfetti] = useState(null);

    const [masterId] = useState(() =>
        Number(sessionStorage.getItem("masterId"))
    );

    useEffect(() => {
        console.log("masterid ===== ", masterId);
    }, [masterId]);

    // [
    //     {
    //         "sspiQuestionId": 1,
    //         "sspiResponseAnswerOption": 1
    //     },
    //     {
    //         "sspiQuestionId": 2,
    //         "sspiResponseAnswerOption": 4
    //     }
    // ]

    useEffect(() => {
        console.log("selectedAnswers ===== ", selectedAnswers);
    }, [selectedAnswers]);

    useEffect(() => {
        setJsConfetti(new JSConfetti());
    }, []);

    useEffect(() => {
        console.log("QUESTIONS ================= ", questions);
    }, [questions]);

    // Fetch quiz questions
    useEffect(() => {
        /**
         * Taking "quizId" from local storage
         */
        const quizId = Number(localStorage.getItem("quizId"));
        const subjectId = Number(sessionStorage.getItem("subjectId"));

        const loadAssessmentQuestionList = async () => {
            try {
                // const response = await studentQuizQuestionsByIdAPI(quizId);
                const response = await assessmentQuestionListAPI();
                const filteredData = response?.data.filter(
                    (d) => d.sspiMasterId === masterId
                );
                console.log("filteredData ========= ", filteredData);
                setQuestions(filteredData || []);
            } catch (err) {
                setError(
                    "Failed to load quiz questions. Please try again later."
                );
                console.error("Fetch error:", err);
            } finally {
                setLoading((prev) => ({ ...prev, questions: false }));
            }
        };
        loadAssessmentQuestionList();
    }, []);

    // Timer logic
    useEffect(() => {
        if (timeLeft <= 0) {
            handleSubmit();
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

    const handleAnswerSelect = (questionId, answer) => {
        const optionNumber =
            Object.keys(options).findIndex((key) => options[key] === answer) +
            1;

        // setSelectedAnswers((prev) => [
        //     ...prev,
        //     {
        //         "sspiQuestionId": questionId,
        //         "sspiResponseAnswerOption": optionNumber,
        //     }
        // ]);

        setSelectedAnswers((prev) => {
            const exist = prev.some(
                (option) => option.sspiQuestionId === questionId
            );

            if (!exist) {
                return [
                    ...prev,
                    {
                        sspiQuestionId: questionId,
                        sspiResponseAnswerOption: optionNumber,
                    },
                ];
            }

            return prev.map((option) =>
                option.sspiQuestionId === questionId
                    ? {
                          ...option,
                          sspiResponseAnswerOption: optionNumber,
                      }
                    : option
            );
        });
    };

    const handleQuestionNavigation = (index) => {
        setCurrentIndex(index);
    };

    const handleSubmit = async () => {
        try {
            setLoading((prev) => ({ ...prev, submission: true }));

            const sspiResponseData = {
                sspiMasterId: masterId,
                data: selectedAnswers,
            };

            console.log("sspiResponseData ======== ", sspiResponseData);

            const response = await assessmentSubmissionAPI(sspiResponseData);
            console.log("response ====== ", response);

            setAssessmentResponse(response?.data.data);

            setTimeout(() => {
                setOpen(true);
            }, 500);

            // console.log("Submission Response: ", response);

            // Trigger confetti
            if (jsConfetti) {
                jsConfetti.addConfetti({
                    confettiColors: [
                        "#FF5E78",
                        "#5AC8FA",
                        "#85E065",
                        "#FF9500",
                        "#8E44AD",
                        "#FF073A",
                    ],
                });
            }

            // Small delay to show confetti before navigation
            // setTimeout(() => {
            //     navigate(
            //         "/StudentDashboard/Quiz/QuizContent/QuizCompletionPage",
            //         {
            //             state: {
            //                 questions,
            //                 userAnswers: selectedAnswers,
            //                 apiResponse: response.data,
            //             },
            //         }
            //     );
            // }, 1000);
        } catch (err) {
            console.error("Submission error:", err);
            setError(
                err.data?.message ||
                    "Failed to submit quiz. Please check your answers and try again."
            );
        } finally {
            setLoading((prev) => ({ ...prev, submission: false }));
        }
    };

    useEffect(() => {
        console.log("assessmentResponse =========== ", assessmentResponse);
    }, [assessmentResponse]);

    if (loading.questions && !questions.length) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                    {error.includes("validation") && (
                        <Box component="ul" sx={{ pl: 2, mt: 1 }}>
                            {Object.entries(error.errors || {}).map(
                                ([field, messages]) =>
                                    messages.map((message, i) => (
                                        <li key={`${field}-${i}`}>{message}</li>
                                    ))
                            )}
                        </Box>
                    )}
                </Alert>
                <Button
                    variant="contained"
                    onClick={() => window.location.reload()}
                    sx={{ mt: 2 }}
                >
                    Retry
                </Button>
            </Box>
        );
    }

    if (!questions.length) {
        return (
            <Box sx={{ p: 3 }}>
                <Typography variant="h6">
                    No questions available for this quiz
                </Typography>
            </Box>
        );
    }

    const currentQuestion = questions[currentIndex];
    // console.log("currentQuestion ==== ", currentQuestion)

    const options = currentQuestion?.sspiOptions?.[0] || {};
    // console.log("options ==== ", options)

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    width: "calc(100vw - 60px)",
                    padding: "20px",
                    height: "100vh",
                    left: "60px",
                    backgroundColor: "#F8F9FD",
                }}
            >
                <Breadcrumb />
                <Box sx={{ display: "flex" }}>
                    {/* Questions Index Sidebar */}
                    <Paper
                        sx={{
                            width: 250,
                            p: 2,
                            overflow: "auto",
                            borderRadius: 0,
                            borderRight: "1px solid #e0e0e0",
                            height: "calc(100vh - 84px)",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{ mb: 2, fontWeight: "bold" }}
                        >
                            Questions
                        </Typography>
                        <Divider />
                        <List>
                            {questions.map((question, index) => (
                                <ListItem
                                    key={question.quizQuestionId}
                                    disablePadding
                                    sx={{ mb: 1 }}
                                >
                                    <ListItemButton
                                        selected={currentIndex === index}
                                        onClick={() =>
                                            handleQuestionNavigation(index)
                                        }
                                        sx={{
                                            borderRadius: 1,
                                            bgcolor:
                                                currentIndex === index
                                                    ? "#e3f2fd"
                                                    : "transparent",
                                            "&:hover": { bgcolor: "#f1f1f1" },
                                        }}
                                    >
                                        <ListItemText
                                            primary={`Question ${index + 1}`}
                                            secondary={
                                                // selectedAnswers[
                                                //     question.quizQuestionId
                                                // ]
                                                selectedAnswers.find(
                                                    (ans) =>
                                                        ans.sspiQuestionId ===
                                                        question.sspiQuestionId
                                                )
                                                    ? "Answered"
                                                    : "Unanswered"
                                            }
                                            secondaryTypographyProps={{
                                                color: selectedAnswers.find(
                                                    (ans) =>
                                                        ans.sspiQuestionId ===
                                                        question.sspiQuestionId
                                                )
                                                    ? "success.main"
                                                    : "text.secondary",
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    </Paper>

                    {/* Main Quiz Content */}
                    <Box
                        sx={{
                            flex: 1,
                            p: 3,
                            overflow: "auto",
                            // border: "2px solid red",
                        }}
                    >
                        <Box
                            sx={{
                                bgcolor: "background.paper",
                                p: 3,
                                borderRadius: 2,
                                boxShadow: 1,
                                maxWidth: 800,
                                mx: "auto",
                                // border: "2px solid blue",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 3,
                                    // border: "2px solid yellow",
                                }}
                            >
                                <Typography variant="h6">
                                    Question {currentIndex + 1} of{" "}
                                    {questions.length}
                                </Typography>
                                <Typography
                                    variant="h6"
                                    color={
                                        timeLeft < 60
                                            ? "error.main"
                                            : "text.primary"
                                    }
                                >
                                    Time Left: {formatTime(timeLeft)}
                                </Typography>
                            </Box>

                            <Typography
                                variant="h5"
                                gutterBottom
                                sx={
                                    {
                                        // border: "2px solid purple",
                                    }
                                }
                            >
                                {currentQuestion.sspiQuestionDetail}
                            </Typography>

                            <FormControl
                                component="fieldset"
                                sx={{ mt: 2, width: "100%" }}
                            >
                                <RadioGroup
                                    value={
                                        options[
                                            `sspiOption${
                                                selectedAnswers.find(
                                                    (ans) =>
                                                        ans.sspiQuestionId ===
                                                        currentQuestion.sspiQuestionId
                                                )?.sspiResponseAnswerOption
                                            }`
                                        ] || ""
                                    }
                                    onChange={(e) =>
                                        handleAnswerSelect(
                                            currentQuestion.sspiQuestionId,
                                            e.target.value
                                        )
                                    }
                                >
                                    {/* QUESTIONS OPTIONS FOR SELECTION */}
                                    {[1, 2, 3, 4].map((optNum) => (
                                        <FormControlLabel
                                            key={optNum}
                                            value={
                                                options[`sspiOption${optNum}`]
                                            }
                                            control={<Radio />}
                                            onClick={() => {
                                                currentIndex >=
                                                    questions.length - 1 &&
                                                    setIsLastQuestion(false);
                                            }}
                                            label={
                                                options[`sspiOption${optNum}`]
                                            }
                                            sx={{
                                                mb: 1,
                                                p: 1,
                                                borderRadius: 1,
                                                "&:hover": {
                                                    bgcolor: "#f5f5f5",
                                                },
                                            }}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    mt: 4,
                                    pt: 2,
                                    borderTop: "1px solid",
                                    borderColor: "divider",
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() =>
                                        handleQuestionNavigation(
                                            currentIndex - 1
                                        )
                                    }
                                    disabled={currentIndex === 0}
                                >
                                    Previous
                                </Button>

                                {currentIndex < questions.length - 1 ? (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() =>
                                            handleQuestionNavigation(
                                                currentIndex + 1
                                            )
                                        }
                                        disabled={
                                            // !selectedAnswers[
                                            // currentQuestion.quizQuestionId
                                            // ]
                                            !selectedAnswers.find(
                                                (ans) =>
                                                    ans.sspiQuestionId ===
                                                    currentQuestion.sspiQuestionId
                                            )
                                        }
                                    >
                                        Next
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={handleSubmit}
                                        // disabled={loading.submission}
                                        disabled={isLastQuestion}
                                    >
                                        {loading.submission ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            "Submit Quiz"
                                        )}
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <ModalComp
                    open={open}
                    navigate={navigate}
                    isError={isError}
                    sspiQuestionList={questions}
                    sspiSubmissionResponse={assessmentResponse}
                    userSubmittedAnswer={selectedAnswers}
                />
            </Box>
        </>
    );
};

const ModalComp = ({
    open,
    navigate,
    isError,
    sspiQuestionList,
    sspiSubmissionResponse,
    userSubmittedAnswer,
}) => {
    // sspiQuestionList = [
    //     {
    //         sspiQuestionId: 1,
    //         sspiQuestionDetail:
    //             "Which of the following is an example of a physical change?",
    //         sspiExamId: 1,
    //         examName: "Initial",
    //         sspiSubjectId: 1,
    //         subjectName: "Science",
    //         classId: 1,
    //         className: "8th",
    //         sspiYear: 2025,
    //         sspiIsActive: true,
    //         sspiOptions: [
    //             {
    //                 sspiOption1: "Burning of paper",
    //                 sspiOption2: "Rusting of iron",
    //                 sspiOption3: "Melting of ice",
    //                 sspiOption4: "Cooking of rice",
    //             },
    //         ],
    //     },
    //     {
    //         sspiQuestionId: 2,
    //         sspiQuestionDetail: "Lightning is caused due to —",
    //         sspiExamId: 1,
    //         examName: "Initial",
    //         sspiSubjectId: 1,
    //         subjectName: "Science",
    //         classId: 1,
    //         className: "8th",
    //         sspiYear: 2025,
    //         sspiIsActive: true,
    //         sspiOptions: [
    //             {
    //                 sspiOption1: "Heating of clouds",
    //                 sspiOption2: "Electrical discharge in the sky",
    //                 sspiOption3: " Motion of clouds",
    //                 sspiOption4: "Friction between air molecules",
    //             },
    //         ],
    //     },
    // ];

    // sspiSubmissionResponse = [
    //     {
    //         sspiResponseId: 0,
    //         userId: 4,
    //         sspiQuestionId: 1,
    //         sspiResponseAnswerOption: 3,
    //         sspiIsAnswerCorrect: true,
    //         sspiMarksObtained: 20,
    //         sspiResponseDateTime: "2025-06-26T18:06:00.2761411+05:30",
    //     },
    //     {
    //         sspiResponseId: 0,
    //         userId: 4,
    //         sspiQuestionId: 2,
    //         sspiResponseAnswerOption: 4,
    //         sspiIsAnswerCorrect: true,
    //         sspiMarksObtained: 20,
    //         sspiResponseDateTime: "2025-06-26T18:06:00.2806648+05:30",
    //     },
    // ];

    // userSubmittedAnswer = [
    //     {
    //         sspiQuestionId: 1,
    //         sspiResponseAnswerOption: 1,
    //     },
    //     {
    //         sspiQuestionId: 2,
    //         sspiResponseAnswerOption: 4,
    //     },
    // ];

    const resultMappingObject = userSubmittedAnswer.map((a, idx) => {
        return {
            sspiQuestionId: a?.sspiQuestionId,
            sspiQuestionDetail: sspiQuestionList.find(
                (b) => b?.sspiQuestionId === a?.sspiQuestionId
            ).sspiQuestionDetail,
            userSelectedOption: sspiQuestionList.find(
                (b) => b?.sspiQuestionId === a?.sspiQuestionId
            ).sspiOptions[0][`sspiOption${a?.sspiResponseAnswerOption}`],
            correctOption: sspiQuestionList.find(
                (b) => b?.sspiQuestionId === a?.sspiQuestionId
            ).sspiOptions[0][
                `sspiOption${
                    sspiSubmissionResponse.find(
                        (b) => b?.sspiQuestionId === a?.sspiQuestionId
                    )?.sspiCorrectAnswerOption
                }`
            ],
            marksObtained: sspiSubmissionResponse.find(
                (b) => b?.sspiQuestionId === a?.sspiQuestionId
            )?.sspiMarksObtained,
            sspiIsAnswerCorrect: sspiSubmissionResponse.find(
                (b) => b?.sspiQuestionId === a?.sspiQuestionId
            )?.sspiIsAnswerCorrect,
        };
    });

    // -------------- HARD CODED DATA --------------
    // const resultMappingObject = [
    //     {
    //         sspiQuestionId: 1,
    //         sspiQuestionDetail:
    //             "Which of the following is an example of a physical change?",
    //         userSelectedOption: "Burning of paper",
    //         correctOption: "Burning of paper",
    //         marksObtained: 20,
    //         sspiIsAnswerCorrect: true,
    //     },
    //     {
    //         sspiQuestionId: 2,
    //         sspiQuestionDetail: "Lightning is caused due to —",
    //         userSelectedOption: "Friction between air molecules",
    //         correctOption: "Friction between air molecules",
    //         marksObtained: 20,
    //         sspiIsAnswerCorrect: true,
    //     },
    //     {
    //         sspiQuestionId: 3,
    //         sspiQuestionDetail:
    //             "Water boils at what temperature under normal atmospheric pressure?",
    //         userSelectedOption: "100°C",
    //         correctOption: "100°C",
    //         marksObtained: 20,
    //         sspiIsAnswerCorrect: true,
    //     },
    //     {
    //         sspiQuestionId: 4,
    //         sspiQuestionDetail:
    //             "Which gas do plants absorb from the atmosphere?",
    //         userSelectedOption: "Oxygen",
    //         correctOption: "Carbon dioxide",
    //         marksObtained: 0,
    //         sspiIsAnswerCorrect: false,
    //     },
    //     {
    //         sspiQuestionId: 5,
    //         sspiQuestionDetail: "Which planet is known as the Red Planet?",
    //         userSelectedOption: "Mars",
    //         correctOption: "Mars",
    //         marksObtained: 20,
    //         sspiIsAnswerCorrect: true,
    //     },
    //     {
    //         sspiQuestionId: 6,
    //         sspiQuestionDetail: "What is H2O commonly known as?",
    //         userSelectedOption: "Hydrogen peroxide",
    //         correctOption: "Water",
    //         marksObtained: 0,
    //         sspiIsAnswerCorrect: false,
    //     },
    //     {
    //         sspiQuestionId: 7,
    //         sspiQuestionDetail: "Which of these is not a state of matter?",
    //         userSelectedOption: "Plasma",
    //         correctOption: "Radiation",
    //         marksObtained: 0,
    //         sspiIsAnswerCorrect: false,
    //     },
    //     {
    //         sspiQuestionId: 8,
    //         sspiQuestionDetail:
    //             "Which organ in the human body is primarily responsible for filtering blood?",
    //         userSelectedOption: "Kidney",
    //         correctOption: "Kidney",
    //         marksObtained: 20,
    //         sspiIsAnswerCorrect: true,
    //     },
    //     {
    //         sspiQuestionId: 9,
    //         sspiQuestionDetail:
    //             "Photosynthesis occurs in which part of the plant?",
    //         userSelectedOption: "Roots",
    //         correctOption: "Leaves",
    //         marksObtained: 0,
    //         sspiIsAnswerCorrect: false,
    //     },
    //     {
    //         sspiQuestionId: 10,
    //         sspiQuestionDetail: "Sound cannot travel through —",
    //         userSelectedOption: "Vacuum",
    //         correctOption: "Vacuum",
    //         marksObtained: 20,
    //         sspiIsAnswerCorrect: true,
    //     },
    // ];

    //   sample response
    // [
    //   {
    //     sspiQuestionId: 1,
    //     sspiQuestionDetail:
    //       "Which of the following is an example of a physical change?",
    //     userSelectedOption: "Burning of paper",
    //     correctOption: "Melting of ice",
    //     marksObtained: 20,
    //     sspiIsAnswerCorrect: true,
    //   },
    //   {
    //     sspiQuestionId: 2,
    //     sspiQuestionDetail: "Lightning is caused due to —",
    //     userSelectedOption: "Friction between air molecules",
    //     correctOption: "Friction between air molecules",
    //     marksObtained: 20,
    //     sspiIsAnswerCorrect: true,
    //   },
    // ]

    useEffect(() => {
        console.log("resultMappingObject ===== ", resultMappingObject);
    }, [resultMappingObject]);

    // console.log(
    //     sspiQuestionList,
    //     sspiSubmissionResponse
    // );

    const calculateScore = () => {
        let obtainedScore = 0;
        let totalScore = 0;

        resultMappingObject.map((rmo) => {
            if (rmo.sspiIsAnswerCorrect) obtainedScore += rmo.marksObtained;
        });

        resultMappingObject.map((rmo) => {
            totalScore += 20;
        });

        return { obtainedScore, totalScore };
    };

    const { obtainedScore, totalScore } = calculateScore();
    const assessmentPercentage = Math.round((obtainedScore / totalScore) * 100);

    return (
        <>
            {isError ? (
                <Modal
                    open={open}
                    // onClose={setOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 450,
                            bgcolor: "background.paper",
                            borderRadius: 3,
                            boxShadow: 10,
                            p: 4,
                            outline: "none",
                            maxHeight: "80vh",
                            overflowY: "auto",
                        }}
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h4"
                            component="h2"
                            sx={{
                                color: "red",
                            }}
                        >
                            Please connect with admin
                        </Typography>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                navigate(
                                    "/StudentDashboard/Course/CourseContent"
                                );
                            }}
                            sx={{
                                width: "100%",
                                mt: "20px",
                            }}
                        >
                            Continue the Course
                        </Button>
                    </Box>
                </Modal>
            ) : (
                <Modal
                    open={open}
                    // onClose={setOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "70%",
                            bgcolor: "background.paper",
                            borderRadius: 3,
                            boxShadow: 10,
                            p: 4,
                            outline: "none",
                            maxHeight: "80vh",
                            overflowY: "auto",
                        }}
                    >
                        <Typography variant="h4" gutterBottom align="center">
                            Assignment Results
                        </Typography>
                        <Typography variant="h5" gutterBottom align="center">
                            Score: {obtainedScore}/{totalScore} points
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            align="center"
                            gutterBottom
                        >
                            {assessmentPercentage + "%"}
                            {/* 99% */}
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        {resultMappingObject.map((assessmentCheckObj, idx) => {
                            return (
                                <Box key={idx} sx={{ mb: 3 }}>
                                    <Stack
                                        direction="row"
                                        alignItems="flex-start"
                                        spacing={1}
                                    >
                                        {assessmentCheckObj.sspiIsAnswerCorrect ? (
                                            <CheckCircleIcon
                                                color="success"
                                                sx={{ mt: 0.5 }}
                                            />
                                        ) : (
                                            <CancelIcon
                                                color="error"
                                                sx={{ mt: 0.5 }}
                                            />
                                        )}
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Typography
                                                variant="h6"
                                                component="div"
                                            >
                                                Question {idx + 1}:{" "}
                                                {
                                                    assessmentCheckObj.sspiQuestionDetail
                                                }
                                            </Typography>

                                            <Box sx={{ ml: 2, mt: 1 }}>
                                                <Typography>
                                                    <strong>
                                                        Your answer:
                                                    </strong>{" "}
                                                    <span
                                                        style={{
                                                            color: assessmentCheckObj.sspiIsAnswerCorrect
                                                                ? "#4caf50"
                                                                : "#f44336",
                                                        }}
                                                    >
                                                        {
                                                            assessmentCheckObj.userSelectedOption
                                                        }
                                                    </span>
                                                </Typography>
                                                {!assessmentCheckObj.sspiIsAnswerCorrect && (
                                                    <Typography>
                                                        <strong>
                                                            Correct answer:
                                                        </strong>{" "}
                                                        {
                                                            assessmentCheckObj.correctOption
                                                        }
                                                    </Typography>
                                                )}
                                                <Typography>
                                                    <strong>Points:</strong>{" "}
                                                    <span
                                                        style={{
                                                            color: assessmentCheckObj.sspiIsAnswerCorrect
                                                                ? "#4caf50"
                                                                : "#f44336",
                                                        }}
                                                    >
                                                        {assessmentCheckObj.sspiIsAnswerCorrect
                                                            ? assessmentCheckObj.marksObtained
                                                            : 0}
                                                        /20
                                                    </span>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Stack>

                                    <Divider sx={{ mt: 2 }} />
                                </Box>
                            );
                        })}
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                navigate("/StudentDashboard/Assessment");
                            }}
                            sx={{
                                width: "100%",
                                mt: "20px",
                            }}
                        >
                            Continue the Assessment
                        </Button>
                    </Box>
                </Modal>
            )}
        </>
    );
};

export default AssessmentContent;
